import * as THREE from "three";

// Canvases painted on the fly - glyph atlases, radial halos - are handed to the
// GPU as raw pixels rather than as live DOM elements.
//
// three allocates immutable storage for a texture (texStorage2D) and then fills
// it (texSubImage2D). When the source is a <canvas>, Safari measures that fill
// against the canvas's own backing store, which on a Retina display is larger
// than the element's width/height, and rejects the upload:
//
//   WebGL: INVALID_VALUE: glTexSubImage2DRobustANGLE: Offset overflows texture
//   dimensions
//
// The texture is then left black - the code streams simply vanish in Safari. A
// DataTexture carries its own width, height and buffer, so the upload says what
// it means on every browser.
//
// One consequence for callers: a DataTexture is not flipped on upload, so row 0
// of the buffer is the top of the canvas. Shaders sampling these atlases read
// them top-down, without the `1.0 - v` that a CanvasTexture needs.
export function textureFromCanvas(canvas: HTMLCanvasElement, ctx: CanvasRenderingContext2D | null) {
  const pixels = ctx
    ? new Uint8Array(ctx.getImageData(0, 0, canvas.width, canvas.height).data.buffer)
    : new Uint8Array(canvas.width * canvas.height * 4);

  const texture = new THREE.DataTexture(pixels, canvas.width, canvas.height, THREE.RGBAFormat);
  texture.minFilter = THREE.LinearFilter;
  texture.magFilter = THREE.LinearFilter;
  texture.needsUpdate = true;
  return texture;
}
